export default __webpack_public_path__ + "static/1-intro-be59db93acd1d89a5dcbdd0e7f789d41.jpg";